import React from 'react';
import type { OrderStatusUpdateTableProps } from './types';
import OrderStatusUpdateRow from './OrderStatusUpdateRow';

const OrderStatusUpdateTable: React.FC<OrderStatusUpdateTableProps> = ({ updates, brand }) => {
  if (updates.length === 0) {
    return (
      <div
        className="py-8 text-center text-sm"
        style={{ color: brand.colors.textLight }}
      >
        No status updates available
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left">
        <thead>
          <tr
            className="border-b"
            style={{
              backgroundColor: brand.colors.primary,
              color: brand.colors.onPrimary,
              borderColor: brand.colors.border,
            }}
          >
            <th
              className="px-3 py-2 text-xs font-semibold whitespace-nowrap"
            >
              Date/Time
            </th>
            <th
              className="px-3 py-2 text-xs font-semibold"
            >
              Status
            </th>
            <th
              className="px-3 py-2 text-xs font-semibold whitespace-nowrap"
            >
              Related Orders
            </th>
            <th
              className="px-3 py-2 text-xs font-semibold text-center"
            >
              Internal
            </th>
            <th
              className="px-3 py-2 text-xs font-semibold whitespace-nowrap"
            >
              Email Note
            </th>
            <th
              className="px-3 py-2 text-xs font-semibold whitespace-nowrap"
            >
              Status By
            </th>
            <th
              className="px-3 py-2 text-xs font-semibold"
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {updates.map((update) => (
            <OrderStatusUpdateRow
              key={update.id}
              update={update}
              brand={brand}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderStatusUpdateTable;
